export { ImageAlternativeText } from './ImageAlternativeText';
export { ImageAltTextFields } from './ImageAltTextFields';
